export default "__VITE_ASSET__C5JGcm1n__"